import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/ui/reveal";

export default function CtaBand({
    title = "Gotowy, żeby księgowość robiła się sama?",
    subtitle = "Dołącz do listy oczekujących i otrzymaj dostęp jako pierwszy.",
    primary = { label: "Pobierz aplikację", to: "/download" },
    secondary = { label: "Zobacz cennik", to: "/pricing" },
}) {
    return (
        <section className="py-16 lg:py-24">
            <div className="container-gr">
                <Reveal className="relative overflow-hidden rounded-3xl border border-gr-dline bg-gr-primary p-10 text-white sm:p-14 dark:bg-gr-dsecondary">
                    <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-gr-accent/20 blur-3xl" aria-hidden />
                    <div className="relative max-w-2xl">
                        <h2 className="text-3xl tracking-tight text-white sm:text-4xl">{title}</h2>
                        <p className="mt-4 text-white/80">{subtitle}</p>
                        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                            <Link
                                to={primary.to}
                                data-testid="cta-band-primary"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-gr-primary transition-transform hover:brightness-95 active:scale-95"
                            >
                                {primary.label} <ArrowRight className="h-4 w-4" />
                            </Link>
                            {secondary && (
                                <Link
                                    to={secondary.to}
                                    data-testid="cta-band-secondary"
                                    className="inline-flex items-center justify-center rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10 active:scale-95"
                                >
                                    {secondary.label}
                                </Link>
                            )}
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
